










































import Vue from 'vue'
import { ResponsibleEmployee } from '@/model/addresses/ResponsibleEmployee'
import { AddressFunction } from '@/model/addresses/AddressFunction'
import { Employee } from '@/model/companyStructure/Employee'


interface ComponentData {
  selectedFunction: AddressFunction | undefined
  selectedEmployee: Employee | undefined
  validationRules: Array<Function>
}

export default Vue.extend({
  name: 'AddressResponsibleEmployeeDialog',

  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: String,
    employee: Object as () => ResponsibleEmployee,
    employeeList: Array as () => Employee[],
    functionList: Array as () => AddressFunction[],
    loading: Boolean
  },

  data (): ComponentData {
    const required = (value: any): boolean | string => !!value || this.$t('masterData.addresses.required').toString()

    return {
      selectedFunction: undefined,
      selectedEmployee: undefined,
      validationRules: [required]
    }
  },

  computed: {},

  watch: {
    show (): void {
      this.resetForm()
    }
  },

  methods: {
    resetForm () {
      const form: any = this.$refs['form']
      if(form) {
        form.resetValidation()
      }

      if(this.employee && this.employee.id !== null) {
        const foundFunction: AddressFunction | undefined = this.functionList.find((item: AddressFunction) => item.id === this.employee.functionId)
        this.selectedFunction = foundFunction ? foundFunction : undefined
        const foundEmployee: Employee | undefined = this.employeeList.find((item: Employee) => item.id === this.employee.employeeId)
        this.selectedEmployee = foundEmployee ? foundEmployee : undefined
      } else {
        this.selectedFunction = undefined
        this.selectedEmployee = undefined
      }
    },

    onCloseButtonClick (): void {
      this.$emit('close')
      this.resetForm()
    },

    onCancelButtonClick (): void {
      this.$emit('close')
      this.resetForm()
    },

    onSaveButtonClick (): void {
      const form: any = this.$refs['form']
      if (form.validate() && this.employee && this.selectedEmployee && this.selectedFunction) {

        const payload: ResponsibleEmployee = ResponsibleEmployee.Update(this.employee, this.selectedEmployee.id, this.selectedFunction)

        if(payload.id) {
          this.$emit('editResponsibleEmployee', payload)
        } else {
          this.$emit('createNewResponsibleEmployee', payload)
        }
      }
    },
  }
})
